import { clsx } from 'clsx';
import { useCardDrift } from '../../hooks/use-card-drift';
import styles from './calendar-card.module.css';

/** Floating calendar product card for the onboarding constellation. */
export function CalendarCard() {
  const ref = useCardDrift({ amp: 8, speed: 0.08, phase: 3.4 });

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className={styles.card}
    >
      <div className={styles.cardhead}>
        <span className={styles.label}>Calendar</span>
        <span className={styles.windowDots}>
          <span className={styles.windowDot} />
          <span className={styles.windowDot} />
          <span className={styles.windowDot} />
        </span>
      </div>

      <div className={styles.cardbody}>
        <div className={styles.dayLabel}>Today</div>

        {/* Recording row */}
        <div className={clsx(styles.event, styles.eventRec)}>
          <span className={clsx(styles.eventBar, styles.eventRecBar)} />
          <span className={styles.recDot} aria-hidden />
          <span className={styles.eventTitle}>Standup</span>
          <span className={clsx(styles.eventWhen, styles.recWhen)}>REC 04:12</span>
        </div>

        {/* Notes-ready row */}
        <div className={clsx(styles.event, styles.eventNotes)}>
          <span className={clsx(styles.eventBar, styles.eventNotesBar)} />
          <svg
            className={styles.notesIcon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
          >
            <path d="M4 5h12M4 10h16M4 15h10" />
          </svg>
          <span className={styles.eventTitle}>1:1 with Sam</span>
          <span className={clsx(styles.eventWhen, styles.notesWhen)}>Notes ready</span>
        </div>

        {/* Upcoming event */}
        <div className={styles.event}>
          <span className={clsx(styles.eventBar, styles.eventBarAmber)} />
          <span className={styles.eventTitle}>Design review</span>
          <span className={styles.eventWhen}>2:30</span>
        </div>
      </div>
    </div>
  );
}
